module.exports = __webpack_public_path__ + "static/media/ilha_3.eedca4f5.jpg";